export default "__VITE_ASSET__CyEV10Hi__"